<template>
  <div class="marketViewLiveEventDetail market-view" id="marketViewDetail">
    <div class="progress-line-container">
      <v-progress-linear
        indeterminate
        color="primary darken-2"
        v-if="getLoadingDetail"
      ></v-progress-linear>
    </div>
    <transition-group name="card-in-out">
      <v-card
        class="event-card-detail event-card-live-detail"
        elevation="1"
        v-for="(object, index) in getEventsLiveDetail"
        :key="index + '_detail'"
        v-if="!checkIsMobile() && !checkIsTablet()"
      >
        <!-- TODO CREATE AND USE COMPONENT BREADCRUMBPREMATCH AND REUSE THERE -->
        <div
          class="event-card-header"
          v-if="breadcrumbPrematchType === 'default'"
        >
          <span class="label-live">{{ $t('live') }}</span>
          <span class="sport-text" :title="object.sport.name">
            <img
              :src="sportPath + object.sport.id + '.svg'"
              :alt="object.sport.name"
              v-bind:class="{ 'img-sport-light': light }"
            />
            {{ object.sport.name }}
          </span>

          <span class="category-text" :title="object.category.name">
            <v-icon dense>mdi-chevron-right</v-icon>
            <img
              :src="categoryPath + object.category.id + '.svg'"
              :alt="object.category.name"
            />
            {{ object.category.name }}
          </span>

          <span :class="['tournament-text']" :title="object.tournament.name">
            <v-icon dense>mdi-chevron-right</v-icon>
            {{ object.tournament.name }}
          </span>

          <span class="desc-event highlight" :title="object.event.description">
            <v-icon dense>mdi-chevron-right</v-icon>
            {{ object.event.description }}
          </span>

          <span
            class="close-card cursor-pointer"
            @click="removeDetail(object.event.source, object.event.type)"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.7699 1.33324L6.99991 5.11324L3.22991 1.33324C2.9784 1.08173 2.63727 0.94043 2.28158 0.94043C1.92588 0.94043 1.58476 1.08173 1.33324 1.33324C1.08173 1.58476 0.94043 1.92588 0.94043 2.28158C0.94043 2.63727 1.08173 2.9784 1.33324 3.22991L5.11324 6.99991L1.33324 10.7699C1.08173 11.0214 0.94043 11.3625 0.94043 11.7182C0.94043 12.0739 1.08173 12.4151 1.33324 12.6666C1.58476 12.9181 1.92588 13.0594 2.28158 13.0594C2.63727 13.0594 2.9784 12.9181 3.22991 12.6666L6.99991 8.88658L10.7699 12.6666C11.0214 12.9181 11.3625 13.0594 11.7182 13.0594C12.0739 13.0594 12.4151 12.9181 12.6666 12.6666C12.9181 12.4151 13.0594 12.0739 13.0594 11.7182C13.0594 11.3625 12.9181 11.0214 12.6666 10.7699L8.88658 6.99991L12.6666 3.22991C12.7911 3.10537 12.8899 2.95753 12.9573 2.79481C13.0247 2.63209 13.0594 2.4577 13.0594 2.28158C13.0594 2.10545 13.0247 1.93106 12.9573 1.76834C12.8899 1.60563 12.7911 1.45778 12.6666 1.33324C12.542 1.20871 12.3942 1.10992 12.2315 1.04252C12.0688 0.97512 11.8944 0.94043 11.7182 0.94043C11.3625 0.94043 11.0214 1.08173 10.7699 1.33324Z"
              />
            </svg>
          </span>
        </div>
        <div
          class="event-card-header breadcrumb"
          v-if="breadcrumbPrematchType === 'beauty-1'"
        >
          <div class="breadcrumb">
            <span class="label-live">{{ $t('live') }}</span>
            <div class="separator"></div>

            <span class="sport-text" :title="object.sport.name">
              {{ object.sport.name }}
            </span>
            <div class="separator"></div>

            <span class="category-text" :title="object.category.name">
              <img
                :src="categoryPath + object.category.id + '.svg'"
                :alt="object.category.name"
              />
              {{ object.category.name }}
            </span>
            <div class="separator"></div>

            <span :class="['tournament-text']" :title="object.tournament.name">
              {{ object.tournament.name }}
            </span>
            <div class="separator"></div>

            <span
              class="desc-event highlight"
              :title="object.event.description"
            >
              {{ object.event.description }}
            </span>
          </div>

          <span
            class="close-card cursor-pointer"
            @click="removeDetail(object.event.source, object.event.type)"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.7699 1.33324L6.99991 5.11324L3.22991 1.33324C2.9784 1.08173 2.63727 0.94043 2.28158 0.94043C1.92588 0.94043 1.58476 1.08173 1.33324 1.33324C1.08173 1.58476 0.94043 1.92588 0.94043 2.28158C0.94043 2.63727 1.08173 2.9784 1.33324 3.22991L5.11324 6.99991L1.33324 10.7699C1.08173 11.0214 0.94043 11.3625 0.94043 11.7182C0.94043 12.0739 1.08173 12.4151 1.33324 12.6666C1.58476 12.9181 1.92588 13.0594 2.28158 13.0594C2.63727 13.0594 2.9784 12.9181 3.22991 12.6666L6.99991 8.88658L10.7699 12.6666C11.0214 12.9181 11.3625 13.0594 11.7182 13.0594C12.0739 13.0594 12.4151 12.9181 12.6666 12.6666C12.9181 12.4151 13.0594 12.0739 13.0594 11.7182C13.0594 11.3625 12.9181 11.0214 12.6666 10.7699L8.88658 6.99991L12.6666 3.22991C12.7911 3.10537 12.8899 2.95753 12.9573 2.79481C13.0247 2.63209 13.0594 2.4577 13.0594 2.28158C13.0594 2.10545 13.0247 1.93106 12.9573 1.76834C12.8899 1.60563 12.7911 1.45778 12.6666 1.33324C12.542 1.20871 12.3942 1.10992 12.2315 1.04252C12.0688 0.97512 11.8944 0.94043 11.7182 0.94043C11.3625 0.94043 11.0214 1.08173 10.7699 1.33324Z"
              />
            </svg>
          </span>
        </div>
        <v-row class="ma-0">
          <v-col
            class="pl-0 py-0"
            cols="12"
            :md="liveEventListPosition === 'liveDetail' ? '8' : '12'"
          >
            <v-row
              class="event-card-intro no-padding no-margin"
              :style="
                'background-image: url(\'' +
                sportBackgroundPath +
                object.sport.id +
                '.webp\');height: 150px;background-size: cover;'
              "
              v-if="object.event.type == 'match' && !getField(object.event)"
            >
              <v-col
                cols="12"
                md="5"
                :class="[
                  'no-padding',
                  'align-middle',
                  'flex-end',
                  getLoser(object.event.livescore.Scoreboard.Results, 'home')
                    ? 'loser'
                    : '',
                ]"
              >
                <div class="competitor">
                  <div class="name">
                    {{ object.event.competitors.home.name }}
                  </div>
                </div>
                <div class="team-result-home">
                  {{
                    getResult(object.event.livescore.Scoreboard.Results, 'home')
                  }}
                </div>
              </v-col>

              <v-col
                cols="12"
                md="2"
                class="no-padding align-middle flex-center"
              >
                <div class="match-date">
                  <span
                    class="time"
                    v-if="
                      getMatchCurrentTime(
                        object.event.livescore.Scoreboard.Time
                      ) > 0
                    "
                  >
                    <v-progress-circular
                      :rotate="270"
                      :size="90"
                      :width="5"
                      :value="
                        getMatchCurrentTime(
                          object.event.livescore.Scoreboard.Time
                        )
                      "
                      color="white"
                    >
                      {{
                        getMatchCurrentTime(
                          object.event.livescore.Scoreboard.Time
                        )
                      }}
                      <span class="blink_me">'</span>
                    </v-progress-circular>
                  </span>
                  <span class="current-period">{{
                    getMatchCurrentPeriod(
                      object.event.livescore.Scoreboard.CurrentPeriod
                    )
                  }}</span>
                </div>
              </v-col>

              <v-col
                cols="12"
                md="2"
                :class="[
                  'no-padding',
                  'align-middle',
                  'flex-start',
                  getLoser(object.event.livescore.Scoreboard.Results, 'away')
                    ? 'loser'
                    : '',
                ]"
              >
                <div class="team-result-away">
                  {{
                    getResult(object.event.livescore.Scoreboard.Results, 'away')
                  }}
                </div>
                <div class="competitor away">
                  <div class="name">
                    {{ object.event.competitors.away.name }}
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row
              class="event-card-intro no-padding no-margin"
              :style="
                'background-image: url(\'' +
                sportBackgroundDetailPath +
                object.sport.id +
                '.webp\');background-size: cover;background-position: center center;'
              "
              v-else-if="object.event.type == 'match' && getField(object.event)"
            >
              <div class="d-flex-center" style="display: flex; flex: 5 1 auto">
                <v-col
                  cols="12"
                  md="5"
                  :class="[
                    'align-middle',
                    getLoser(object.event.livescore.Scoreboard.Results, 'home')
                      ? 'loser'
                      : '',
                  ]"
                  style="justify-content: flex-end"
                >
                  <div class="competitor competitor-with-field">
                    <div class="name">
                      {{ object.event.competitors.home.name }}
                    </div>
                  </div>
                  <div class="team-result-home team-result-home-with-field">
                    {{
                      getResult(
                        object.event.livescore.Scoreboard.Results,
                        'home'
                      )
                    }}
                  </div>
                </v-col>

                <v-col cols="12" md="2" class="align-middle flex-center">
                  <div class="match-date">
                    <span
                      class="time"
                      v-if="
                        getMatchCurrentTime(
                          object.event.livescore.Scoreboard.Time
                        ) > 0
                      "
                    >
                      <v-progress-circular
                        :rotate="270"
                        :size="90"
                        :width="5"
                        :value="
                          getMatchCurrentTime(
                            object.event.livescore.Scoreboard.Time
                          )
                        "
                        color="white"
                      >
                        {{
                          getMatchCurrentTime(
                            object.event.livescore.Scoreboard.Time
                          )
                        }}
                        <span class="blink_me">'</span>
                      </v-progress-circular>
                    </span>
                    <span class="current-period">{{
                      getMatchCurrentPeriod(
                        object.event.livescore.Scoreboard.CurrentPeriod
                      )
                    }}</span>
                    <span
                      v-if="
                        getUserType == 4 ||
                        getCashier ||
                        !getSettings.enableQuickBetOnlyForAgency
                      "
                      class="event-qbet"
                      title="qbet"
                    >
                      {{ object.event.quickbet }}
                    </span>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="5"
                  :class="[
                    'align-middle',
                    'flex-start',
                    getLoser(object.event.livescore.Scoreboard.Results, 'away')
                      ? 'loser'
                      : '',
                  ]"
                >
                  <div class="team-result-away team-result-away-with-field">
                    {{
                      getResult(
                        object.event.livescore.Scoreboard.Results,
                        'away'
                      )
                    }}
                  </div>
                  <div class="competitor away competitor-with-field">
                    <div class="name">
                      {{ object.event.competitors.away.name }}
                    </div>
                  </div>
                </v-col>
              </div>
              <div
                style="display: flex; flex: auto; justify-content: flex-end"
                v-if="enableLiveField"
              >
                <LiveFieldWidget></LiveFieldWidget>
              </div>
            </v-row>
            <v-row class="no-padding no-margin" style="min-height: 900px">
              <v-col
                cols="12"
                sm="12"
                md="12"
                v-if="object.event.type == 'match'"
                style="
                  padding-top: 12px;
                  padding-bottom: 12px;
                  padding-left: 0px;
                  padding-right: 0px;
                "
              >
                <v-tabs
                  v-model="tab"
                  grow
                  class="tabs-list"
                  :class="
                    getUseMarketOddsGroupV2 === 'scrollable-1' ? 'v2' : ''
                  "
                >
                  <!--              <v-tab class="group-tab" v-for="group in object.groupMarkets" :key="group.id"-->
                  <!--                     @click="getOddsGroup(object.event.id, group.group_id,object.sport.id,(object.tournament.id)?object.tournament.id:'')">-->
                  <!--                {{ group.name }}-->
                  <!--              </v-tab>-->
                  <v-tab
                    class="group-tab"
                    v-for="group in getMarketsGroupsDetailLive"
                    :key="
                      'groupTabEventLiveDetail-' +
                      object.event.id +
                      '-' +
                      group._id
                    "
                    @click="
                      getOddsGroup(
                        object.event.id,
                        group._id,
                        object.sport.id,
                        object.tournament.id ? object.tournament.id : ''
                      )
                    "
                  >
                    {{
                      group.languages.length > 0 && group.languages[0].text
                        ? group.languages[0].text
                        : group.name != null
                        ? group.name
                        : 'MarketGroup'
                    }}

                    <!--                  {{group._id}}-->
                  </v-tab>
                </v-tabs>

                <!-- todo remember to insert again the check locked on market like the default live module -->
                <v-tabs-items v-model="tab">
                  <v-tab-item
                    v-for="group in getMarketsGroupsDetailLive"
                    :key="
                      'detailTabItemLive-' +
                      object.event.id +
                      '-' +
                      group._id +
                      '-' +
                      group.name
                    "
                  >
                    <!--                                <div class="deleteMe">{{group}} </div>-->
                    <v-card color="basil" flat v-if="!tab_loading">
                      <masonry :cols="1" :gutter="20">
                        <v-expansion-panels
                          focusable
                          v-model="expansionPanelMarkets"
                          multiple
                        >
                          <template
                            v-if="
                              getGroupedMarkets(object.event.odds).length > 0
                            "
                          >
                            <v-expansion-panel
                              v-if="
                                marketGroup != null && marketGroup[0] != null
                              "
                              v-for="(marketGroup, index) in getGroupedMarkets(
                                object.event.odds
                              )"
                              :key="
                                'detailExpansionPanelLive-' +
                                object.event.id +
                                '-' +
                                marketGroup[0].id_market +
                                index
                              "
                            >
                              <v-expansion-panel-header>
                                {{ marketGroup[0].name_market }}
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <div>
                                  <div
                                    v-for="(market, index) in marketGroup"
                                    :key="market.unique_id"
                                  >
                                    <template v-if="checkLocked(market)">
                                      <!--                                                      <div class="market-header">-->
                                      <!--                                                          {{ market.name_market }} {{ (market.specifiers != "") ? market.specifiers : '' }}-->
                                      <!--                                                      </div>-->
                                      <div
                                        class="extended-odds-container col-sm-12 col-md-12 col-lg-12 col-xl-12"
                                        :class="index % 2 == 0 ? 'even' : 'odd'"
                                      >
                                        <div class="col-md-3">
                                          <div
                                            class="market-header"
                                            style="
                                              font-size: 9pt !important;
                                              font-weight: 700 !important;
                                              padding-right: 0.5rem !important;
                                            "
                                          >
                                            {{
                                              market.specifiers != ''
                                                ? market.name_market
                                                : ''
                                            }}
                                            {{
                                              market.specifiers != ''
                                                ? market.specifiers
                                                : ''
                                            }}
                                          </div>
                                        </div>
                                        <div class="col-md-9 contein">
                                          <div class="row contein2">
                                            <div
                                              v-for="(
                                                odd, index
                                              ) in market.odds"
                                              :key="'live_odd_' + odd.unique_id"
                                              v-if="
                                                (odd.active ||
                                                  (market.showLocked &&
                                                    !odd.active)) &&
                                                !odd.unique_id.includes(
                                                  'undefined'
                                                )
                                              "
                                              @click="
                                                putCart(
                                                  odd,
                                                  object.event,
                                                  object.sport,
                                                  object.category,
                                                  object.tournament
                                                )
                                              "
                                              :class="[
                                                'extended',
                                                'no-padding',
                                                getSizeOddButtonForMarket(
                                                  odd.id_market
                                                ),
                                              ]"
                                            >
                                              <div
                                                :class="[
                                                  'value',
                                                  'extended-odd',
                                                  'multi-' +
                                                    market.multiplicity_min,
                                                  odd.type_change != undefined
                                                    ? 'odd_value_' +
                                                      odd.type_change
                                                    : 'odd_value_equal',
                                                  getOddsSources.includes(
                                                    odd.unique_id
                                                  )
                                                    ? 'odd_selected'
                                                    : '',
                                                ]"
                                                v-if="
                                                  odd.outcome_odd_value > 1.0 &&
                                                  odd.active
                                                "
                                              >
                                                <div
                                                  class="extended_sign_value"
                                                  style="width: 45%"
                                                >
                                                  {{ odd.outcome_name }}
                                                </div>

                                                <div
                                                  class="arrow-odd-changed-container"
                                                >
                                                  <template
                                                    v-if="
                                                      odd.type_change == 'up'
                                                    "
                                                  >
                                                    <img
                                                      src="@/assets/svg/live-arrow-up.svg"
                                                      width="12"
                                                      height="12"
                                                    />
                                                  </template>
                                                  <template
                                                    v-else-if="
                                                      odd.type_change == 'down'
                                                    "
                                                  >
                                                    <img
                                                      src="@/assets/svg/live-arrow-down.svg"
                                                      width="12"
                                                      height="12"
                                                    />
                                                  </template>
                                                </div>
                                                <div
                                                  class="extended_odd_value"
                                                  style="width: 45%"
                                                >
                                                  <!-- todo per gli special value devo tenere cmq il vecchio comortamento di illuminazione quando la quota cambia -->
                                                  {{
                                                    odd.outcome_odd_value
                                                      | odds_type_filter
                                                  }}
                                                </div>
                                              </div>
                                              <div
                                                v-else
                                                :class="[
                                                  'value',
                                                  'extended-view-locked multi-' +
                                                    market.multiplicity_min,
                                                ]"
                                              >
                                                <div
                                                  class="extended_sign_value"
                                                >
                                                  {{ odd.outcome_name }}
                                                </div>
                                                <div class="extended_odd_value">
                                                  <!-- todo per gli special value devo tenere cmq il vecchio comortamento di illuminazione quando la quota cambia -->
                                                  <v-icon dense>
                                                    mdi-lock
                                                  </v-icon>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                </div>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </template>
                        </v-expansion-panels>
                      </masonry>
                    </v-card>
                    <v-card v-else>
                      <v-skeleton-loader
                        v-bind="attrs"
                        type="date-picker"
                      ></v-skeleton-loader>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="LiveEventsVerticalScrollerInsideContainer"
            cols="12"
            md="4"
            v-if="liveEventListPosition === 'liveDetail'"
          >
            <LiveMatchTracker v-if="getViewLiveMatchTracker"></LiveMatchTracker>
            <LiveEventsVerticalScroller></LiveEventsVerticalScroller>
          </v-col>
        </v-row>
      </v-card>

      <v-card
        class="event-card-detail event-card-live-detail event-card-live-detail-mobile"
        elevation="1"
        v-for="(object, index) in getEventsLiveDetail"
        :key="object.event.source"
        v-else-if="checkIsMobile() || checkIsTablet()"
      >
        <div class="event-card-header">
          <span class="sport-text" :title="object.sport.name">
            <img
              :src="sportPath + object.sport.id + '.svg'"
              :alt="object.sport.name"
              v-bind:class="{ 'img-sport-light': light }"
            />
          </span>
          <span class="category-text" :title="object.category.name">
            <img
              :src="categoryPath + object.category.id + '.svg'"
              :alt="object.category.name"
            />
          </span>
          <span class="desc-event highlight" :title="object.event.description">
            {{ object.event.description }}
          </span>
          <span
            class="close-card cursor-pointer"
            @click="removeDetail(object.event.source, object.event.type)"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.7699 1.33324L6.99991 5.11324L3.22991 1.33324C2.9784 1.08173 2.63727 0.94043 2.28158 0.94043C1.92588 0.94043 1.58476 1.08173 1.33324 1.33324C1.08173 1.58476 0.94043 1.92588 0.94043 2.28158C0.94043 2.63727 1.08173 2.9784 1.33324 3.22991L5.11324 6.99991L1.33324 10.7699C1.08173 11.0214 0.94043 11.3625 0.94043 11.7182C0.94043 12.0739 1.08173 12.4151 1.33324 12.6666C1.58476 12.9181 1.92588 13.0594 2.28158 13.0594C2.63727 13.0594 2.9784 12.9181 3.22991 12.6666L6.99991 8.88658L10.7699 12.6666C11.0214 12.9181 11.3625 13.0594 11.7182 13.0594C12.0739 13.0594 12.4151 12.9181 12.6666 12.6666C12.9181 12.4151 13.0594 12.0739 13.0594 11.7182C13.0594 11.3625 12.9181 11.0214 12.6666 10.7699L8.88658 6.99991L12.6666 3.22991C12.7911 3.10537 12.8899 2.95753 12.9573 2.79481C13.0247 2.63209 13.0594 2.4577 13.0594 2.28158C13.0594 2.10545 13.0247 1.93106 12.9573 1.76834C12.8899 1.60563 12.7911 1.45778 12.6666 1.33324C12.542 1.20871 12.3942 1.10992 12.2315 1.04252C12.0688 0.97512 11.8944 0.94043 11.7182 0.94043C11.3625 0.94043 11.0214 1.08173 10.7699 1.33324Z"
              />
            </svg>
          </span>
        </div>

        <v-row v-if="checkIsMobile() && getViewLiveMatchTracker">
          <LiveMatchTracker></LiveMatchTracker>
        </v-row>

        <v-row
          class="event-card-intro no-padding no-margin"
          :style="
            'background-image: url(\'' +
            sportBackgroundDetailPath +
            object.sport.id +
            '.webp\');background-position: bottom;'
          "
          v-if="object.event.type == 'match' && !getViewLiveMatchTracker"
        >
          <div class="d-flex-center" style="display: flex; flex: 5 1 auto">
            <v-col
              xs="2"
              :class="[
                'align-middle',
                getLoser(object.event.livescore.Scoreboard.Results, 'home')
                  ? 'loser'
                  : '',
              ]"
            >
              <div class="competitor competitor-with-field">
                <div class="name">{{ object.event.competitors.home.name }}</div>
              </div>
            </v-col>
            <v-col xs="8" class="align-middle flex-center">
              <div class="match-date">
                <div class="result">
                  <div class="team-result-home">
                    {{
                      getResult(
                        object.event.livescore.Scoreboard.Results,
                        'home'
                      )
                    }}
                  </div>
                  <div class="separator">:</div>
                  <div class="team-result-away">
                    {{
                      getResult(
                        object.event.livescore.Scoreboard.Results,
                        'away'
                      )
                    }}
                  </div>
                </div>
                <div class="info-live">
                  <span class="current-period"
                    >{{
                      getMatchCurrentTime(
                        object.event.livescore.Scoreboard.Time
                      )
                    }}
                    <span class="blink_me">'</span> -
                    {{
                      getMatchCurrentPeriod(
                        object.event.livescore.Scoreboard.CurrentPeriod
                      )
                    }}
                  </span>
                </div>
              </div>
            </v-col>

            <v-col
              xs="2"
              :class="[
                'align-middle',
                getLoser(object.event.livescore.Scoreboard.Results, 'away')
                  ? 'loser'
                  : '',
              ]"
              style="justify-content: flex-end"
            >
              <div class="competitor away competitor-with-field">
                <div class="name">{{ object.event.competitors.away.name }}</div>
              </div>
            </v-col>
          </div>

          <div
            style="display: flex; flex: auto; justify-content: flex-end"
            v-if="enableLiveField"
          >
            <LiveFieldWidget></LiveFieldWidget>
          </div>

          <div
            style="
              display: flex;
              flex: 0 0 100%;
              justify-content: center;
              margin-top: -15px;
            "
          >
            <span style="font-size: 10px">{{ object.tournament.name }}</span>
          </div>
        </v-row>

        <v-row
          class="no-padding no-margin event-card-detail detail-mobile"
          style="height: auto"
        >
          <v-col
            cols="12"
            md="12"
            style="padding: 0px !important"
            v-if="object.event.type == 'match'"
          >
            <v-col
              cols="12"
              id="container_group_markets_event_detail_odds_mobile"
            >
              <v-btn-toggle v-model="marketGroupSelected">
                <v-col
                  class="marketGroupContainer"
                  cols="4"
                  v-for="group in getMarketsGroupsDetailLive"
                  :key="group._id + '-' + group.name"
                >
                  <v-btn
                    small
                    tile
                    class="marketGroup"
                    depressed
                    block
                    @click="
                      getOddsGroup(
                        object.event.id,
                        group._id,
                        object.sport.id,
                        object.tournament.id ? object.tournament.id : ''
                      )
                    "
                  >
                    <span class="text-sport text-capitalize">
                      {{
                        group.languages.length > 0 && group.languages[0].text
                          ? group.languages[0].text
                          : group.name != null
                          ? group.name
                          : 'MarketGroup'
                      }}</span
                    >
                  </v-btn>
                </v-col>
              </v-btn-toggle>
            </v-col>

            <!-- todo remember to insert again the check locked on market like the default live module -->
            <v-card
              color="basil"
              flat
              v-if="!tab_loading"
              class="group-odds-mobile"
              style="border: none"
            >
              <masonry :cols="1">
                <v-expansion-panels
                  focusable
                  v-model="expansionPanelMarkets"
                  multiple
                >
                  <!-- todo add no odds available else  -->
                  <template
                    v-if="getGroupedMarkets(object.event.odds).length > 0"
                  >
                    <v-expansion-panel
                      v-if="
                        marketGroup != null &&
                        marketGroup[0] != null &&
                        marketGroup[0].odds != null
                      "
                      v-for="(marketGroup, index) in getGroupedMarkets(
                        object.event.odds
                      )"
                      :key="'mobile_marketgroup_live' + index"
                    >
                      <v-expansion-panel-header
                        ><span style="padding-left: 6px">{{
                          marketGroup != null ? marketGroup[0].name_market : ''
                        }}</span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div
                          class="market-box"
                          v-for="(market, index) in marketGroup"
                          :key="market.unique_id"
                        >
                          <template v-if="needShow(market)">
                            <div
                              v-if="market.specifiers != ''"
                              class="market-header"
                            >
                              {{ market.name_market }} {{ market.specifiers }}
                            </div>
                            <div class="market-content-odds-list">
                              <div
                                v-for="(odd, index) in market.odds"
                                class="odd"
                                :key="odd.unique_id"
                                v-if="
                                  (odd.active ||
                                    (market.showLocked && !odd.active)) &&
                                  !odd.unique_id.includes('undefined')
                                "
                                @click="
                                  putCart(
                                    odd,
                                    object.event,
                                    object.sport,
                                    object.category,
                                    object.tournament
                                  )
                                "
                                :class="[
                                  getOddsSources.includes(odd.unique_id)
                                    ? 'odd_selected'
                                    : '',
                                ]"
                              >
                                <v-col cols="12" class="odd-outcome-name">
                                  {{ odd.outcome_name }}
                                  {{ getSpecifiers(odd.market_unique_id) }}
                                </v-col>
                                <v-col
                                  v-if="
                                    odd.outcome_odd_value > 1.0 && odd.active
                                  "
                                  cols="12"
                                  class="odd-outcome-value"
                                  :class="
                                    odd.type_change != undefined
                                      ? 'odd_value_' + odd.type_change
                                      : 'odd_value_equal'
                                  "
                                >
                                  <template
                                    v-if="
                                      odd.type_change === 'up' ||
                                      odd.type_change === 'down'
                                    "
                                  >
                                    <span
                                      class="arrow-odd-changed-container arrow-odd-changed-container-mobile"
                                    >
                                      <template v-if="odd.type_change === 'up'">
                                        <img
                                          src="@/assets/svg/live-arrow-up.svg"
                                          width="12"
                                          height="12"
                                        />
                                      </template>

                                      <template
                                        v-else-if="odd.type_change === 'down'"
                                      >
                                        <img
                                          src="@/assets/svg/live-arrow-down.svg"
                                          width="12"
                                          height="12"
                                        />
                                      </template>
                                    </span>

                                    <span style="width: 90%">
                                      {{
                                        odd.outcome_odd_value | odds_type_filter
                                      }}
                                    </span>
                                  </template>
                                  <template v-else>
                                    <span>
                                      {{
                                        odd.outcome_odd_value | odds_type_filter
                                      }}
                                    </span>
                                  </template>
                                </v-col>
                                <div v-else class="locked">
                                  <v-icon dense>mdi-lock</v-icon>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </template>
                </v-expansion-panels>
              </masonry>
            </v-card>
            <v-card v-else>
              <v-skeleton-loader
                v-bind="attrs"
                type="date-picker"
              ></v-skeleton-loader>
            </v-card>
            <!--              </v-tab-item>-->
            <!--            </v-tabs-items>-->
          </v-col>
        </v-row>
      </v-card>
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import _ from "lodash";
import LiveFieldWidget from '@/components/generic/LiveFieldWidget'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '../../../plugins/device-inspector'
import LiveEventsVerticalScroller from '@/components/left_widgets/LiveEventsVerticalScroller.vue'

const Statscore = () => ({
  component: import('@/components/right_widgets/Statscore'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const LiveMatchTracker = () => ({
  component: import('@/components/right_widgets/LiveMatchTracker'),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'MarketViewLiveDetail',
  components: {
    LiveFieldWidget,
    LiveMatchTracker,
    Statscore,
    LiveEventsVerticalScroller,
  },
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    enableLiveField: false,
    attrs: {
      class: 'mb-6',
      boilerplate: true,
      elevation: 2,
    },
    groupSelected: 0,
    tab: null,
    tab_loading: false,
    loading: false,
    antepostType: ['stage', 'season', 'simple_tournament'],
    categoryPath:
      process.env.VUE_APP_URL_CLOUDFRONT +
      '/svg/categories/rectangular_flags_category/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons/',
    light: window.icons == 'light' ? true : false,
    flagTeamsPath: process.env.VUE_APP_URL_FLAG_TEAMS_CLOUDFRONT + '/medium/',
    sportBackgroundPath:
      'https://rocky-revenge.s3.eu-west-1.amazonaws.com/svg/sports-bg/',
    sportBackgroundDetailPath:
      'https://rocky-revenge.s3.eu-west-1.amazonaws.com/svg/sports-bg-detail/',
    noOdds: false,
    expansionPanelMarkets: [],
    marketGroupSelected: 0,
    uniqueMarketsIdsActiveAtMount: [],
    eventId: null,
  }),
  watch: {
    tab(newValue, oldValue) {
      // console.log('tab is changed');
      // this.updateUniqueMarketsIdsActiveAtMounting();
      this.openFirstExpansionPanelMarkets()
    },
    getEventsLiveDetail(newValue, oldValue) {
      const eventId =
        newValue && newValue[0] && newValue[0].event && newValue[0].event.id
          ? newValue[0].event.id
          : null
      this.eventId = eventId

      this.updateUniqueMarketsIdsActiveAtMounting()
      this.setViewLiveMatchTracker(true)
    },
    eventId(newValue, oldValue) {
      if (newValue != null && newValue != oldValue) {
        this.groupSelected = 0
      }
    },
  },
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getFilter: 'tree/getFilter',
      getEventsLiveDetail: 'odds/getEventsLiveDetail',
      getLoadingDetail: 'odds/getLoadingDetail',
      getOddsSources: 'cart/getOddsSources',
      getRulesManager: 'rules/getRulesManager',
      getRulesSkin: 'rules/getRulesSkin',
      getPlatformId: 'settings/getPlatformId',
      getUserType: 'user/getType',
      getCashier: 'user/getCashier',
      getSettings: 'cart/getSettings',
      getMarketsGroupsDetailLive: 'odds/getMarketsGroupsDetailLive',
      getMarketOrderForEventDetailLive:
        'marketview/getMarketOrderForEventDetailLive',
      getMobileMarketOrderForEventDetailLive:
        'marketview/getMobileMarketOrderForEventDetailLive',
      getMarketsMapSizeButtonsDetailLive:
        'marketview/getMarketsMapSizeButtonsDetailLive',
      getViewLiveMatchTracker: 'odds/getViewLiveMatchTracker',
      breadcrumbPrematchType: 'uiConfig/breadcrumbPrematchType',
      getUseMarketOddsGroupV2: 'uiConfig/marketsGroupLayout',
      liveEventListPosition: 'uiConfig/liveEventListPosition',
    }),
  },
  methods: {
    ...mapActions({
      setFilter: 'tree/setFilter',
      removeFromLiveDetail: 'odds/removeFromLiveDetail',
      fetchEventLiveDetail: 'odds/fetchEventLiveDetail',
      fetchOddsGroupLiveDetail: 'odds/fetchOddsGroupLiveDetail',
      setLoadingDetail: 'odds/setLoadingDetail',
      addOddToCart: 'cart/addOddToCart',
      setEventStatscore: 'odds/setEventStatscore',
      setViewLiveMatchTracker: 'odds/setViewLiveMatchTracker',
    }),

    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },

    removeDetail(sourceEvent, type) {
      this.tab = null
      this.removeFromLiveDetail({ source: sourceEvent, type: type })
      this.$root.$emit('forceUpdateLivePreview')

      this.marketGroupSelected = 0
      // this.$root.$emit('forceCloseStatscore')
    },

    async getOddsGroup(eventSource, groupId, sport, tournament) {
      if (groupId != this.groupSelected) {
        this.groupSelected = groupId
        this.tab_loading = true
        await this.setLoadingDetail({ status: true })

        await this.fetchEventLiveDetail({
          source: eventSource,
          group: groupId,
          sport: sport,
          tournament: tournament,
          tab: this.tab,
        })

        await this.setLoadingDetail({ status: false })
        this.tab_loading = false
      }
    },

    async putCart(odd, event, sport, category, tournament) {
      if (odd.outcome_odd_value > 0 && odd.active) {
        await this.addOddToCart({
          odd: odd,
          event: event,
          sport: sport,
          category: category,
          tournament: tournament,
        })
        this.$root.$emit('forceUpdateSingleMultiple')
        this.$root.$emit('forceUpdateIntegral')
        this.$root.$emit('forceUpdateSystem')
      }
    },
    getMatchCurrentTime(time) {
      if (time >= 0) {
        const minutes = Math.floor(time / 60)
        return minutes
      } else {
        return 0
      }
    },
    getResult(result, team) {
      if (team == 'home') {
        var point = _.find(result, { Position: '1' })
        return point ? +point.Value : 0
      } else if (team == 'away') {
        var point = _.find(result, { Position: '2' })
        return point ? +point.Value : 0
      } else {
        return 0
      }
    },
    getMatchCurrentPeriod(period) {
      let find = _.find(period, { lang: this.getLanguage })
      if (find) {
        return find.text
      } else {
        find = _.find(period, { lang: 'en' })
        if (find) {
          return find.text
        } else {
          return ''
        }
      }
    },
    getLoser(result, type) {
      const home_point = _.find(result, { Position: '1' })
      const away_point = _.find(result, { Position: '2' })
      if (type == 'home') {
        return +home_point.Value < +away_point.Value
      } else if (type == 'away') {
        return +away_point.Value < +home_point.Value
      }
    },
    getField(object) {
      return true
    },
    isActiveMarket(odds) {
      const check = _.find(odds, { active: true })
      if (check) {
        return true
      } else {
        return false
      }
    },
    checkHugeMarket(odds) {
      return _.size(odds) > 10 ? true : false
    },
    checkLocked(market) {
      //remove this magic number and understand what market is... for this old logic
      if (market.id_market == 9607444846 || market.id_market == 7055540925) {
        return true
      } else {
        if (market.odds) {
          const check = _.find(market.odds, { active: true })
          return !(market.odds.length >= 2 && !check)
        } else {
          return false
        }
      }
    },
    wasPresentAtMountingPage(market) {
      if (this.uniqueMarketsIdsActiveAtMount.includes(market.unique_id)) {
        return true
      } else {
        return false
      }
    },
    needShow(market) {
      if (this.wasPresentAtMountingPage(market) || this.checkLocked(market)) {
        return true
      } else {
        return false
      }
    },
    getSpecifiers(spec) {
      let result = ''

      if (!spec) {
        return result
      }

      if (spec.includes('#')) {
        const split = spec.split('#')
        if (split[1].includes(':')) {
          result = '(' + split[1] + ')'
        } else if (split[1].includes('(') && split[1].includes('.')) {
          result = ' [' + split[1] + '] '
        } else if (split[1] != '') {
          result = split[1]
        }

        if (_.size(split) > 2) {
          return result + ' ' + split[2]
        } else {
          return result
        }
      } else {
        return result
      }
    },
    checkExists(odds) {
      let result = false
      _.forEach(odds, market => {
        _.forEach(market.odds, odd => {
          if (odd.active == true) {
            result = true
          }
        })
      })

      return result
    },
    getGroupedMarkets(marketOdds) {
      const vm = this
      const mapMarketIdOrder = new Map()
      const filteredMarketOdds = Object.fromEntries(
        Object.entries(marketOdds).filter(([key, value]) => vm.needShow(value))
      )

      for (const element of Object.entries(filteredMarketOdds)) {
        mapMarketIdOrder.set(element[1].id_market, +element[0])
      }

      const refactored = _.groupBy(filteredMarketOdds, 'id_market')

      const orderedMarkets = []
      for (const idKey of mapMarketIdOrder.keys()) {
        let found = false

        for (const groupMarket of Object.values(refactored)) {
          if (groupMarket[0].id_market == idKey) {
            if (found == false) {
              orderedMarkets.push(groupMarket)
              found = true
            }
          }
        }
      }
      return orderedMarkets
    },
    getSizeOddButtonForMarket(marketId) {
      let sizeButtons = 'col-md-2 col-lg-2 col-xl-2'
      try {
        marketId = marketId.toString()
        const marketSizeButtons = this.getMarketsMapSizeButtonsDetailLive

        const marketIndex = marketSizeButtons.findIndex(marketButtonInfo => {
          return marketButtonInfo.marketId === marketId
        })

        if (marketIndex != -1) {
          sizeButtons =
            'col-' +
            marketSizeButtons[marketIndex].sizeOddButtonMd +
            ' ' +
            'col-' +
            marketSizeButtons[marketIndex].sizeOddButtonLg +
            ' ' +
            'col-' +
            marketSizeButtons[marketIndex].sizeOddButtonXl
        }
      } catch (e) {
        console.log(e)
      }

      return sizeButtons
    },
    openFirstExpansionPanelMarkets() {
      const NUMBER_OF_PANELS_TO_OPEN = 100
      this.expansionPanelMarkets = []

      for (let i = 0; i < NUMBER_OF_PANELS_TO_OPEN; i++) {
        this.expansionPanelMarkets.push(i)
      }
    },
    updateUniqueMarketsIdsActiveAtMounting() {
      const backUp = this.getEventsLiveDetail
      const oddsBackup = backUp[0].event.odds

      const arrayOfMarkets = []
      for (const obj of Object.values(oddsBackup)) {
        arrayOfMarkets.push(obj)
      }

      const filteredLocked = arrayOfMarkets.filter(el => {
        return this.checkLocked(el)
      })

      const uniqueIdsActiveAtTheMounting = []

      for (const marketGroup of filteredLocked) {
        uniqueIdsActiveAtTheMounting.push(marketGroup.unique_id)
      }

      this.uniqueMarketsIdsActiveAtMount = uniqueIdsActiveAtTheMounting
    },
  },
  async mounted() {
    /* todo change all the key on this component live */
    const vm = this

    this.$root.$on('resetTabLiveEventDetailMarketGroup', function () {
      vm.tab = null
    })
    this.updateUniqueMarketsIdsActiveAtMounting()
    this.openFirstExpansionPanelMarkets()
  },

  beforeDestroy() {
    this.$root.$off('resetTabLiveEventDetailMarketGroup', () => {})
  },
}
</script>

<style>
.bet-console-prefix
  .market-view
  .event-card-detail.detail-mobile
  .group-odds-mobile.v-card {
  height: auto;
}

.marketViewLiveEventDetail.market-view .market-header {
  font-size: 9pt !important;
  font-weight: 700 !important;
  padding-right: 0.5rem !important;
}

.contein {
  display: flex;
  float: right;
  flex-direction: row;
  justify-content: flex-end;
}

.contein2 {
  height: auto !important;
  display: flex;
  float: right;
  flex-direction: row;
  justify-content: flex-end;
  padding: 4px;
}
</style>
